import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  min-height: 100vh;
  background: ${({ theme: { colors } }) => colors("background")};
  color: ${({ theme: { colors } }) => colors("highlight")};
  font-family: 'Silkscreen', monospace;
  @media (max-width: 600px) { padding: 0.5rem; }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
`;

export const ToolbarDivider = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${({ theme: { colors } }) => colors("highlight", 0.2)};
  margin: 0 0.35rem;
`;

export const EditWindow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const BoardScroller = styled.div`
  overflow-x: auto;
  overflow-y: auto;
  max-width: 100%;
  max-height: 80vh;
  flex-shrink: 1;
  -webkit-overflow-scrolling: touch;
`;

export const Board = styled.div`
  position: relative;
  flex-shrink: 0;
  border: 1px solid ${({ theme: { colors } }) => colors("highlight", 0.3)};
`;

export const Row = styled.div`
  ${({ width, height }) => `
    position: relative;
    width: ${width}px;
    height: ${height}px;
    display: flex;
  `}
`;

export const Sidebar = styled.div`
  border: 1px solid ${({ theme: { colors } }) => colors("highlight", 0.3)};
  padding: 0.75rem;
  width: 400px;
  flex-shrink: 0;
  box-sizing: border-box;
  background: ${({ theme: { colors } }) => colors("background")};
  @media (max-width: 600px) { width: 100%; }
`;

export const EntityDot = styled.div`
  ${({ color, size = 12 }) => `
    position: absolute;
    width: ${size}px;
    height: ${size}px;
    background: ${color};
    border: 1px solid rgba(255,255,255,0.8);
    border-radius: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%);
    z-index: 5;
  `}
`;
